// src/utils/crewAssignment.js
//
// THE reading of a crew pick (docs/features/crew_by_org_id_FEATURE.md, ticket E56U4u6tAqafSE19DWRz).
//
// The crew tasks ("Assign Site Survey / Installation / Inspection / Miscellaneous Crew") are choice fields over
// `organizations` that store the organization's DOCUMENT ID (mapping.valueField '__docId__'). The name is looked up
// where a person reads it, from the organization's `profile.name`: renaming an organization renames it on every
// screen and breaks no saved pick. Crews are compared by id everywhere (scheduling conflicts, calendar, the install
// board); a name is never a key.
//
// Mirror of functions-shared/utils/crewAssignment.js (same pure functions, CJS). npm run test:crew-by-org-id pins the
// parity.

export const CREW_TASK_IDS = Object.freeze({
  siteSurvey: 'Fg8Em7ZbRHKZRCF7ND9a',
  installation: 'NhwfXdMLqGbSSyFKu9ZK',
  inspection: '0jPujY5keJ31BWj7mkEg',
  miscellaneous: 'BkRIHxlNUewVkzZypuF0',
})

/** A stored crew pick → the organization's id (unwraps the compound { status, value } shape); null when unset. */
export function crewOrgId(value) {
  const raw = value && typeof value === 'object' && !Array.isArray(value) ? value.value : value
  if (typeof raw !== 'string') return null
  const id = raw.trim()
  return id || null
}

/** An organization's name, as every screen shows it: profile.name (the V2 organization shape). */
export function organizationName(org) {
  const name = org && org.profile ? org.profile.name : null
  return typeof name === 'string' ? name.trim() : ''
}
